module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAElBMVEUAAAA0NDQzMzMyMjIyMjIzMzPfhUt+AAAABXRSTlMAQL9/3ym2Td0AAABbSURBVAjXNYxLCoAgFEWPinMJnJvSXAI30ArMcP9bid4zuHAP3A+ACSB+TCW/2yQQMfcCFGzaupbn+GfLXbuC3rQhWazxkXYmFwrfWW7EgOmcGV9xCd9xFYPqBRwyCIcBY64/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/HellowWorld/name_img.png
// module id = dAft
// module chunks = 41